import { translateKey } from '../../../../../translate';

export enum AddCarePathSteps {
    assignRoles = 1,
    chooseCarePath = 0,
    settings = 2,
}

export const addCarePathSteps = ({ isEpisodePreselected }: { isEpisodePreselected: boolean }) => [
    { title: translateKey(`episodeCategory.${isEpisodePreselected ? 'chooseService' : 'chooseEpisodeCategory'}`) },
    { title: translateKey('episodeCategory.assignRoles') },
    { title: translateKey('episodeCategory.organizationSettings') },
];
